import styled from 'styled-components'

export const InputErrorMessage = styled.div`
  margin-top: 0.25rem;
  color: #fc5457;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/components/InputErrorMessage/InputErrorMessage.tsx